// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--dec33";
export var list = "Slide-module--list--d97ca";
export var description = "Slide-module--description--935f5";
export var figure = "Slide-module--figure--3f182";
export var link = "Slide-module--link--a7ac9";
export var name = "Slide-module--name--0bb67";
export var linkedinIcon = "Slide-module--linkedinIcon--20c9a";
export var position = "Slide-module--position--e4e93";
export var picture = "Slide-module--picture--620ca";
export var img = "Slide-module--img--f266a";
export var figcaption = "Slide-module--figcaption--bd283";